// Automatically generated
export const USE_RADIO_STATE_KEYS = [
  "baseId",
  "unstable_virtual",
  "rtl",
  "orientation",
  "currentId",
  "loop",
  "wrap",
  "shift",
  "unstable_includesBaseElement",
  "defaultState",
  "state",
  "onStateChange",
] as const;
export const RADIO_STATE_KEYS = [
  "baseId",
  "unstable_idCountRef",
  "unstable_virtual",
  "rtl",
  "orientation",
  "items",
  "groups",
  "currentId",
  "loop",
  "wrap",
  "shift",
  "unstable_moves",
  "unstable_hasActiveWidget",
  "unstable_includesBaseElement",
  "state",
  "setBaseId",
  "registerItem",
  "unregisterItem",
  "registerGroup",
  "unregisterGroup",
  "move",
  "next",
  "previous",
  "up",
  "down",
  "first",
  "last",
  "sort",
  "unstable_setVirtual",
  "setRTL",
  "setOrientation",
  "setCurrentId",
  "setLoop",
  "setWrap",
  "setShift",
  "reset",
  "unstable_setIncludesBaseElement",
  "unstable_setHasActiveWidget",
  "setState",
] as const;
export const RADIO_KEYS = [
  ...RADIO_STATE_KEYS,
  "value",
  "checked",
  "unstable_checkOnFocus",
] as const;
export const RADIO_GROUP_KEYS = RADIO_STATE_KEYS;
